import { newSpecPage } from '@stencil/core/testing';
import { LabDsSearchBar } from './lab-ds-search-bar';

describe('v4text-field', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LabDsSearchBar],
      html: `<lab-ds-search-bar value='oi'/>`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-search-bar value="oi">
    <mock:shadow-root>
       <div class="false v4-input">
           <div class="input-icon">
             <lab-ds-icon-not-selectable class="icon left" icon="search" size="small"></lab-ds-icon-not-selectable>
             <input class="input-field" placeholder="" type="text" value="oi">
             <lab-ds-icon-selectable class="icon right" icon="close" size="small"></lab-ds-icon-selectable>
           </div>
       </div>
    </mock:shadow-root>
     </lab-ds-text-field>
  `);
  });
});
